"use client";

import { Loader2Icon } from "lucide-react";
import { useIntl } from "react-intl";

export function Spinner({ strokeWidth = 3 }: { strokeWidth?: number }) {
  const intl = useIntl();
  return (
    <span
      aria-label={intl.formatMessage({ defaultMessage: "Carregando...", id: "EMLr/e" })}
      className="inline-flex items-center"
    >
      <Loader2Icon className="size-5 animate-spin text-slate-600 dark:text-slate-300" strokeWidth={strokeWidth} />
    </span>
  );
}
